export default "__VITE_PUBLIC_ASSET__a002b007__"